// extracted by mini-css-extract-plugin
export default {"card":"card-class_card__f6KKJ","arrow":"card-class_arrow__UzfSz","expanded":"card-class_expanded__KzL1M"};